import { addDays, backedReserves, paymentInstances, unsettledInstances, type PaymentInstance, type PlainDate } from '@skoka/core';
import type { AppState } from './store.js';

type State = Pick<AppState, 'accounts' | 'obligations' | 'reserves' | 'today' | 'trackingStartedAt'>;

/** Ближайший неоплаченный платёж: сначала известный долг, затем расписание. */
export function nextPaymentInstance(state: State, obligationId: string, date?: PlainDate): PaymentInstance | null {
  const o = state.obligations.find((x) => x.id === obligationId);
  if (!o) return null;
  const reserves = backedReserves({ accounts: state.accounts, reserves: state.reserves, obligations: state.obligations, today: state.today });
  const between = (from: PlainDate, to: PlainDate) => paymentInstances({ obligations: [o], reserves, today: state.today, from, to });
  if (date) return between(date, date)[0] ?? null;
  const late = unsettledInstances({ obligations: [o], reserves, today: state.today,
    ...(state.trackingStartedAt ? { trackingStartedAt: state.trackingStartedAt } : {}),
  })[0];
  return late ?? between(state.today, addDays(state.today, 400)).find((i) => !i.settled) ?? null;
}
